import React from "react";
import { useFormContext } from "react-hook-form";
import { Form } from "@sscs/ui";
import { TokenAlgorithm, TokenAlgorithmOption } from "Types";
import { OIDCSignatureVerificationFormFields } from "../../types";
import FormPanel from "../FormPanel/FormPanel";

// we only support one option for now
export const tokenAlgorithmOptions: TokenAlgorithmOption[] = [
  { label: "RS256 (RSASSA-PKCS1-v1_5 using SHA-256)", id: "RS256" },
];

const SignatureVerification = (): React.JSX.Element => {
  const {
    formState: { errors },
  } = useFormContext<OIDCSignatureVerificationFormFields>();

  return (
    <FormPanel
      title="Signature verification"
      byline="These values will be defined in the admin dashboard of your SSO identity provider"
    >
      <Form.Autocomplete
        label="Signature algorithm"
        isClearable={false}
        name="token_algorithm"
        id="token_algorithm"
        errors={errors}
        helperText="Algorithm used to sign ID tokens"
        getOptionLabel={(option: TokenAlgorithm) => {
          return (
            tokenAlgorithmOptions.find(
              (tokenAlgorithm) => tokenAlgorithm.id === option,
            )?.label ?? ""
          );
        }}
        options={tokenAlgorithmOptions.map((option) => option.id)}
      />
      <Form.TextField
        label="Token audience"
        name="token_audience"
        id="token_audience"
        errors={errors}
        helperText="Identifies the intended recipient of the token"
      />
      <Form.TextField
        label="JWKS endpoint"
        name="jwks_endpoint"
        id="jwks_endpoint"
        errors={errors}
        helperText="URL of your OpenID Connect provider JWKS endpoint"
      />
      <Form.TextField
        label="Issuer"
        name="issuer"
        id="issuer"
        errors={errors}
        helperText="Expected value of the token's iss claim; other issuers are rejected"
      />
    </FormPanel>
  );
};

export default SignatureVerification;
